import gql from 'graphql-tag'
export default gql`
query getUserServiceMapping($userId: String!){
    getUserServiceMapping(userId: $userId){
      id
      siteId
      userId
      serviceId
      type
      serviceName
      boardingAmount
      renewalAmount
      siteOptions
      note
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
  `